import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DragAndDropFileDirective} from './drag-and-drop-file.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [DragAndDropFileDirective],
  exports: [DragAndDropFileDirective]
})
export class DragAndDropFileModule {
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/drag-and-drop-file/drag-and-drop-file.module.ts